import { SerializedPassengerInformation } from '../types/passenger-information'
import { Market } from '../types/booking'
import { useMemo } from 'react'
import { useBrand } from './brand'

export function useMarket (passengers: SerializedPassengerInformation | undefined): Market {
  const brand = useBrand()

  return useMemo(() => {
    if (brand === 'kootstra') {
      return 'kootstra'
    }
    return ['CA', 'US'].includes(passengers?.main.country ?? '-') ? 'north_america' as const : 'default' as const
  }, [brand, passengers?.main.country])
}
